// Settings schema version for future compatibility
export const SETTINGS_VERSION = '1.0.0';

// Default settings structure
export const DEFAULT_SETTINGS = {
  version: SETTINGS_VERSION,
  beta: {
    askPat: false,
  },
  ui: {
    theme: 'light' as 'light' | 'dark',
    colorBlind: false,
  },
  accessibility: {},
};

export interface Settings {
  version: string;
  beta: {
    askPat: boolean;
  };
  ui: {
    theme: 'light' | 'dark';
    colorBlind: boolean;
  };
  accessibility: Record<string, unknown>;
}

// LocalStorage utility functions (primary storage method)
export const setLocalStorage = (key: string, value: string): void => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    }
  } catch (error) {
    console.warn('Failed to save to localStorage:', error);
  }
};

export const getLocalStorage = (key: string): string | null => {
  try {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(key);
    }
    return null;
  } catch (error) {
    console.warn('Failed to read from localStorage:', error);
    return null;
  }
};

export const SETTINGS_KEY = 'app_settings';
